import { useEffect, useState } from "react";
import { ArrowDownRight, ArrowUpRight, BellRing, X } from "lucide-react";
import { api } from "../../lib/api";
import { fmtMoney } from "./kitchenUtils";

// Shows unseen ingredient price changes from applied vendor invoices.
export const PriceAlerts = ({ refreshKey }) => {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    api.get("/admin/kitchen/price-alerts").then((r) => setAlerts(r.data.alerts)).catch(() => {});
  }, [refreshKey]);
  if (!alerts.length) return null;
  const dismiss = async () => {
    await api.post("/admin/kitchen/price-alerts/dismiss");
    setAlerts([]);
  };
  return (
    <div data-testid="price-alerts" className="mt-5 rounded-2xl border border-brand-gold/50 bg-brand-gold/10 p-4 print:hidden">
      <div className="flex items-start justify-between gap-3">
        <p className="flex items-center gap-2 font-bold text-[14px] text-brand-charcoal">
          <BellRing className="h-4 w-4 text-brand-gold-dark" />
          {alerts.length} ingredient price change{alerts.length === 1 ? "" : "s"}
        </p>
        <button type="button" onClick={dismiss} data-testid="price-alerts-dismiss" className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-[0.1em] text-brand-charcoal/60 hover:text-brand-charcoal">
          <X className="h-3.5 w-3.5" /> Mark seen
        </button>
      </div>
      <ul className="mt-2 space-y-1">
        {alerts.map((a) => {
          const up = a.new_cost > a.old_cost;
          const Icon = up ? ArrowUpRight : ArrowDownRight;
          return (
            <li key={a.id} data-testid={`price-alert-${a.ingredient_id}`} className="flex flex-wrap items-center gap-x-2 text-[13px] text-brand-charcoal">
              <Icon className={`h-4 w-4 ${up ? "text-red-600" : "text-brand-teal"}`} />
              <span className="font-bold">{a.ingredient_name}</span>
              <span className="text-brand-charcoal/60">{fmtMoney(a.old_cost)} → {fmtMoney(a.new_cost)}</span>
              {a.pct != null && <span className={`font-bold ${up ? "text-red-600" : "text-brand-teal"}`}>{up ? "+" : ""}{a.pct}%</span>}
              <span className="text-[11.5px] text-brand-charcoal/45">{a.vendor} · {a.invoice_date}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
